import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { merge, startWith, Subscription, switchMap } from 'rxjs';
import { BroadcastMessage, BroadcastMessageStatus } from '../../../../models/broadcast-message.model';
import { BroadcastMessageService } from '../../../../services/broadcast-message.service';
import { SharedService } from '../../../../services/shared.service';
import { MESSAGE } from '../../../../utils/messages';
import { SearchComponent } from '../reusable-component/search/search.component';
import { BroadcastMessageComponent } from './message/broadcast-message.component';
import { CancelBroadcastMessageComponent } from './cancel/cancel-broadcast-message.component';
import { TranslateService } from '../../../../services/translate.service';

@Component({
  selector: 'app-broadcast-messages',
  templateUrl: './broadcast-messages.component.html',
  styleUrls: ['./broadcast-messages.component.scss'],
})
export class BroadcastMessagesComponent implements AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(SearchComponent) search: SearchComponent;
  broadcastMessageData: BroadcastMessage[] = [];
  pageSize = 10;
  total: number;
  displayedColumns: string[] = ['ID', 'TYPE', 'MESSAGE', 'AUDIO_MESSAGE', 'STATUS', 'CREATED_BY', 'START_DATE', 'UPDATED_BY', 'END_DATE', 'ACTION'];
  readonly BroadcastMessageStatus = BroadcastMessageStatus;
  private subscription = new Subscription();

  constructor(
    private broadcastMessageService: BroadcastMessageService,
    private sharedService: SharedService,
    private translateService: TranslateService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.subscription.add(
      merge(this.sort.sortChange, this.paginator.page, this.search.searchBox, this.sharedService.gridReload$)
        .pipe(
          startWith({}),
          switchMap(events => {
            if (typeof events === 'object' && events.hasOwnProperty('searchText')) {
              this.paginator.pageIndex = 0;
            }
            return this.broadcastMessageService.search(
              this.paginator.pageIndex,
              this.paginator.pageSize,
              this.sort.active,
              this.sort.direction,
              this.search.searchText,
            );
          }),
        )
        .subscribe({
          next: data => {
            if (data) {
              this.total = data.totalElements;
              this.broadcastMessageData = data.content;
            } else {
              this.broadcastMessageData = [];
            }
          },
          error: (error: any) => {
            this.sharedService.showMessage(error?.message || MESSAGE.error_broadcast_messages_load);
          },
        }),
    );
  }

  statusDescription (status: BroadcastMessageStatus) {
    return this.translateService.instant(status);
  }

  openDialog() {
    this.dialog.open(BroadcastMessageComponent, {
      width: '460px',
      height: 'auto',
      panelClass: 'custom-dialog-container',
      autoFocus: false,
    });
  }

  cancel(message: BroadcastMessage) {
    this.dialog.open(CancelBroadcastMessageComponent, {
      width: '600px',
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      data: {
        id: message.id,
        infoMessage: message.infoMessage,
        audioMessage: message.audioMessage,
      },
    });
  }

  ngOnDestroy(): void {
    this.dialog.closeAll();
    this.subscription.unsubscribe();
  }
}
